export type DatasheetPrintingSettingsProps = {
  onClose: () => void;
  calculatePaperCount: (params: { format: DatasheetPaperFormat; orientation: DatasheetPaperOrientation }) => number;
  onSubmit: (params: {
    pagesToSkip: number;
    format: DatasheetPaperFormat;
    orientation: DatasheetPaperOrientation;
  }) => void;
};

export enum DatasheetPaperFormat {
  letter = 0,
  legal = 1,
  ledger = 2,
  A3 = 3,
  A4 = 4,
  A5 = 5,
  B4 = 6,
  B5 = 7,
}

export enum DatasheetPaperOrientation {
  landscape = "landscape",
  portrait = "portrait",
}

export type DatasheetPaperFormatConfigProperty = { isoName: string; widthInInches: number; heightInInches: number };
